<script lang="ts">
  import { Card, Col } from "sveltestrap";
  import CreatedByMe from "./CreatedByMe.svelte";
  import TodayTasks from "./TodayTasks.svelte";
  import DelayedTasks from "./DelayedTasks.svelte";
  import UpcomingTasks from "./UpcomingTasks.svelte";
  import ThisWeekTasks from "./ThisWeekTasks.svelte";
  import ThisMonthTasks from "./ThisMonthTasks.svelte";
  import AssignedToMe from "./AssignedToMe.svelte";
  import MyTasks from "./MyTasks.svelte";
  import TasksNotification from "./TasksNotification.svelte";
  import TasksNewsletter from "./TasksNewsletter.svelte";
</script>

<Col xl="9" md="12" class="box-col-8 xl-70">
  <div class="email-right-aside bookmark-tabcontent">
    <Card class="email-body radius-left">
      <div class="ps-0">
        <div class="tab-content">
          <CreatedByMe />
          <TodayTasks />
          <DelayedTasks />
          <UpcomingTasks />
          <ThisWeekTasks />
          <ThisMonthTasks />
          <AssignedToMe />
          <MyTasks />
          <TasksNotification />
          <TasksNewsletter />
        </div>
      </div>
    </Card>
  </div>
</Col>
